var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2744_3639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.75 16.7333C32.1902 13.8962 30.6627 11.3414 28.4284 9.50537C26.1942 7.66935 23.3918 6.66597 20.5 6.66663C15.6833 6.66663 11.5 9.39996 9.41667 13.4C6.96706 13.6647 4.70168 14.8253 3.05581 16.6588C1.40995 18.4924 0.499714 20.8694 0.5 23.3333C0.5 28.85 4.98333 33.3333 10.5 33.3333H32.1667C36.7667 33.3333 40.5 29.6 40.5 25C40.5 20.6 37.0833 17.0333 32.75 16.7333ZM23.8333 21.6666V28.3333H17.1667V21.6666H12.1667L19.9167 13.9166C20.25 13.5833 20.7667 13.5833 21.1 13.9166L28.8333 21.6666H23.8333Z",
    fill: "white",
    fillOpacity: 0.64
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2744_3639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.2902ef9199a0746c77e08fed615e8c96.svg";
export { ForwardRef as ReactComponent };